<template>
      <v-text-field
      :type="typeState"
      :label="label"
      @change="handleInput"
      @blur="handleBlur"
      :required="ifRequired"
      v-model="value"
      :error-messages="errorMessage"
      :append-icon="type == 'password' ? (show ? 'visibility' : 'visibility_off') : null" 
      @click:append="clickIconHandler"
      >
      </v-text-field>
</template>

<script>
export default {


    props:[
        "type",
        "label",
        "defaultValue",
        "ifRequired",
        "errorMessage",
        "error"
    ],
    data: function() { 
      
         
      return({
        value: this.defaultValue,
        show: false,
        typeState: this.type
      })
    },

    methods: {
      handleInput (event) {
        this.$emit('input', event)
      },

      handleBlur (event) {
        this.$emit('blur', event)
      },

      clickIconHandler(){
        this.show = !this.show
        if(this.show){
          this.typeState = "text"
        }else {
          this.typeState = "password"
        }
      },
    },
 
}
</script>

<style>

</style>